export enum TaskType {
    Main = 0,
    Journey = 1,
    Other = 9,
}